// extracted by mini-css-extract-plugin
export default {"tabContainer":"StrokeDecorationControls_tabContainer__vTE5Z","tab":"StrokeDecorationControls_tab__XCHs2","selected":"StrokeDecorationControls_selected__5rGU8"};